import { render, staticRenderFns } from "./GreenGradationButton.vue?vue&type=template&id=21582f2a&scoped=true&"
import script from "./GreenGradationButton.vue?vue&type=script&lang=js&"
export * from "./GreenGradationButton.vue?vue&type=script&lang=js&"
import style0 from "./GreenGradationButton.vue?vue&type=style&index=0&id=21582f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21582f2a",
  null
  
)

export default component.exports